
import axios from "axios";

export default {
    methods: {
        async getChecklistById(token, checklistId) {
            let r = axios
                .request({
                    url: `${this.$store.getters.urlChecklist}/v3/checklist/getdraft?id=${checklistId}&returnAttachmentContent=false&loadIntegrations=false`,
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    return response.data.data;

                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.dispatch("logout").then(() => {
                            this.$router.push("/login");
                        });
                    }
                    console.log(error);
                    console.log(error.response.data.errors);
                    return null;
                });
            return r;
        },
        async getChecklistNew(token, formId) {
            let r = axios
                .request({
                    url: `${this.$store.getters.urlChecklist}/v2/checklist/toFill?formId=${formId}&loadIntegrations=false`,
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    console.log(response);
                    console.log(response.data);

                    let checklist = response.data.data;

                    if (!checklist.id) {
                        checklist.id = 0;
                    }
                    for (let value of checklist.values) {
                        value.attachment = "";
                    }
                    return checklist;
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("logout").then(() => {
                                this.$router.push("/login");
                            });
                        }
                    }
                    console.log(error);
                    console.log(error.response);
                    console.log(error.response.data);
                    console.log(error.response.data.errors);
                    return null;
                });
            return r;
        },
        async getChecklistExitNew(token, formId, checklistId) {
            let r = axios
                .request({
                    url: `${this.$store.getters.urlChecklist}/checklist/exitToFill?formId=${formId}&checklistId=${checklistId}&loadIntegrations=false`,
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    console.log(response.data.data);

                    let checklist = response.data.data;

                    if (!checklist.id) {
                        checklist.id = 0;
                    }
                    for (let value of checklist.values) {
                        value.attachment = "";
                    }
                    return checklist;
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("logout").then(() => {
                                this.$router.push("/login");
                            });
                        }
                    }
                    console.log(error);
                    console.log(error.response);
                    console.log(error.response.data);
                    console.log(error.response.data.errors);
                    return null;
                });
            return r;
        },
    }
}